import { Col } from "reactstrap";
import { P, Ribbon } from "../../../../AbstractElements";
import { RibbonAndTag, RibbonAndTagText } from "../../../../Constant";

export const StaticRightRibbons = () => {
  return (
    <Col sm="6" xl="4">
      <div className="ribbon-wrapper border border-1 height-equal">
        <Ribbon className="ribbon ribbon-dark ribbon-right">50% OFF</Ribbon>
        <P>
          The <em className="txt-danger">{RibbonAndTag}</em>{RibbonAndTagText}
        </P>
      </div>
    </Col>
  );
};
